export function portal(node, config) {
    const { container, at, position = "top", align = "start" } = config;
    const slot = getNode(container) || document.body;
    if (at) {
        node.style.position = "absolute";
        const rect = at.getBoundingClientRect();
        node.style.top = `${rect[position]}px`;
        node.style.left = `${rect[align === "start" ? "left" : "right"]}px`;
    }
    slot.appendChild(node);
    return {
        destroy() {
            node.remove();
        },
    };
}
function getNode(el) {
    if (typeof el === "string") {
        return document.querySelector(el);
    }
    return el;
}
//# sourceMappingURL=portal.js.map